const Last = () => {
  return (
    <div className=" py-4 backfirst flex justify-center text">
      &copy; 2024 Created by Manikandan{" "}
    </div>
  );
};
export default Last;
